import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle, Spinner } from "@phosphor-icons/react";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 text-center">
      <div data-testid="payment-success-page" className="max-w-md">
        {status === "checking" && (
          <>
            <Spinner size={40} className="text-[#D4AF37] animate-spin mx-auto mb-4" />
            <p className="text-[#A1A1AA] tracking-wide">Confirming your payment...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={56} weight="fill" className="text-[#D4AF37] mx-auto mb-4" />
            <h1 className="font-heading text-4xl text-white tracking-tight mb-2">You're In.</h1>
            <p className="text-[#A1A1AA] mb-8">
              Payment confirmed for <span className="text-white">{details?.package_name}</span>. Coach Conde will reach out within 24 hours to schedule your first session.
            </p>
          </>
        )}
        {status === "pending" && (
          <>
            <h1 className="font-heading text-3xl text-white tracking-tight mb-2">Almost There</h1>
            <p className="text-[#A1A1AA] mb-8">We're still confirming your payment. Check your email shortly for confirmation.</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-heading text-3xl text-white tracking-tight mb-2">Something Went Wrong</h1>
            <p className="text-[#A1A1AA] mb-8">We couldn't confirm this payment session.</p>
          </>
        )}
        <Link to="/" data-testid="payment-success-home-link" className="inline-block bg-[#D4AF37] text-black rounded-full px-8 py-3 font-semibold tracking-wide hover:bg-[#c29f2f] transition-colors">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
